import { setMaterial } from './material';
import { addOpening } from './opening';
import { addRoof } from './roof';
import { addStair } from './stair';
import { addStorey } from './storey';
import type { Recipe } from './types';
import { addSlab, addWall } from './wall';

export const RECIPES: Record<string, Recipe> = {
  add_storey: addStorey,
  add_roof: addRoof,
  add_stair: addStair,
  add_wall: addWall,
  add_slab: addSlab,
  add_opening: addOpening,
  set_material: setMaterial,
};

export type { BuildParams, BuildResult, Recipe } from './types';
export { checkBuilding, isRoofElement, type CheckOptions, type Finding } from './findings';
